export const FEEDBACK = "FEEDBACK";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const EDIT_COMPONENT = "EDIT_COMPONENT";
export const PREMIUM_ONLY = "PREMIUM_ONLY";
export const PREMIM_ONLY_SAVE = "PREMIUM_ONLY_SAVE";
export const CANCEL_PREMIUM = "CANCEL_PREMIUM";
